function reversedArray(array) {
  return array.slice(0).reverse();
}

module.exports = reversedArray;



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-router/modules/utils/reversedArray.js
 ** module id = 197
 ** module chunks = 0
 **/